import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function FrontMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            {/* OP Appointment */}

            <h5 className="menu-section-title">OP Appointment</h5>

            <div className="row">

                <MenuCard link="/op-dep" title="Make OP Appointment" icon="fa-solid fa-calendar-check" color="#0d6efd"/>

                <MenuCard link="/op-dashboard" title="OP Dashboard" icon="fa-solid fa-chart-line" color="#20c997"/>

                <MenuCard link="/vitals-view" title="OP Vitals" icon="fa-solid fa-heart-pulse" color="#dc3545"/>

            </div>


            {/* Front Office Billing */}

            <h5 className="menu-section-title">Front Office Billing</h5>

            <div className="row">

                <MenuCard link="/fo-lab-entry" title="Lab Request" icon="fa-solid fa-flask" color="#6f42c1"/>

                <MenuCard link="/fo-inv-entry" title="Investigation Request" icon="fa-solid fa-x-ray" color="#fd7e14"/>

                <MenuCard link="/fo-min-entry" title="Minor Treatment Req." icon="fa-solid fa-syringe" color="#20c997"/>

                <MenuCard link="/refund-entry" title="Refund" icon="fa-solid fa-rotate-left" color="#dc3545"/>
                <MenuCard link="/cancel-entry" title=" Cancel" icon="fa-solid fa-close" color="#dc3545"/>
                <MenuCard link="/due-report" title="OP Due Report" icon="fa-solid fa-file-invoice" color="#0dcaf0"/>

                <MenuCard link="/due-entry" title="Due Payment Request" icon="fa-solid fa-credit-card" color="#6610f2"/>

            </div>


            {/* IP Billing */}

            <h5 className="menu-section-title">IP Billing</h5>

            <div className="row">

                <MenuCard link="/fo-ip-lab-entry" title="IP Lab Request" icon="fa-solid fa-vial" color="#20c997"/>

                <MenuCard link="/fo-ip-inv-entry" title="IP Investigation" icon="fa-solid fa-microscope"
                          color="#fd7e14"/>

            </div>


            {/* Expense */}

            <h5 className="menu-section-title">Expense</h5>

            <div className="row">

                <MenuCard link="/add-expense" title="Add Expense" icon="fa-solid fa-money-bill-wave" color="#dc3545"/>

            </div>


            {/* OP Details */}

            <h5 className="menu-section-title">OP Details</h5>

            <div className="row">

                <MenuCard link="/pat-bill-search" title="Patient Billing Details" icon="fa-solid fa-file-invoice-dollar"
                          color="#0d6efd"/>

                <MenuCard link="/add-patient" title="New Patient Registration" icon="fa-solid fa-user-plus"
                          color="#20c997"/>
                <MenuCard link="/pat-register-search" title="Patients Register Report" icon="fa-solid fa-users"
                          color="#fd7e14"/>

                <MenuCard link="/pat-search" title="Patient ID Print" icon="fa-solid fa-id-card" color="#6f42c1"/>


            </div>


            {/* OP Billing Masters */}

            <h5 className="menu-section-title">OP Billing Masters</h5>

            <div className="row">

                <MenuCard link="/add-minor-cat" title="OP Billing Category" icon="fa-solid fa-layer-group"
                          color="#0dcaf0"/>

                <MenuCard link="/add-minor-comp" title="OP Billing Component" icon="fa-solid fa-cubes" color="#6610f2"/>

                <MenuCard link="/add-consultant" title="Add Consultant" icon="fa-solid fa-user-doctor" color="#20c997"/>

                <MenuCard link="/cons-search" title="Consultant Payment" icon="fa-solid fa-money-check-dollar"
                          color="#dc3545"/>

                <MenuCard link="/cons-pay-report" title="Consultant Payment Report" icon="fa-solid fa-chart-pie"
                          color="#fd7e14"/>

                <MenuCard link="/add-subcat" title="Add Lab Master" icon="fa-solid fa-vial-circle-check"
                          color="#6f42c1"/>

                <MenuCard link="/add-radio" title="Add Radiology Master" icon="fa-solid fa-x-ray" color="#0d6efd"/>

                <MenuCard link="/add-template" title="Add Template Master" icon="fa-solid fa-file-lines"
                          color="#20c997"/>

            </div>

        </section>
    )
}
export default FrontMenu;